// Public
Vue.component('cta-bar', require('./VueComponents/public/CTA-Bar').default);
Vue.component('share-dropdown', require('./VueComponents/public/ShareDropdown').default);
Vue.component('customer-reviews', require('./VueComponents/public/CustomerReviews').default);
Vue.component('customer-review', require('./VueComponents/public/CustomerReview').default);

// Consumer
Vue.component('login-or-register', require('./VueComponents/Consumer/LoginOrRegister').default);
Vue.component('register-new-customer', require('./VueComponents/Consumer/NewCustomerRegistration').default);
Vue.component('email-verification-notification', require('./VueComponents/Consumer/Helpers/EmailVerified').default);

// Producers
Vue.component('register-new-producer', require('./VueComponents/Producer/ProducerRegistrationForm').default);
Vue.component('nps-slider', require('./VueComponents/Producer/NPSSlider').default);
